import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledIconButton = styled(IconButton)`
    & .SWReactIcons svg path {
        fill: ${colorsPalettes.carbon[300]};
    }
    &:hover .SWReactIcons svg path {
        fill: ${colorsPalettes.carbon[300]};
    }
`;
